type PlusTextProps = {
  textSize?: number
}

export const PlusText = (props: PlusTextProps) => {
  const { textSize } = props

  return (
    <div
      style={{
        opacity: '1!important',
        width: 'fit-content',
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      <span
        style={{
          fontFamily: 'Inter',
          fontWeight: 550,
          fontSize: `${textSize}px`,
          lineHeight: '18px',
          color: 'rgba(74, 107, 252, 1)',
          paddingRight: '8px',
        }}
      >
        Plus
      </span>
      <img
        src="/assets/svg/gamedStar.svg"
        alt=""
        style={{
          position: 'absolute',
          left: '100%',
          bottom: '0',
          transform: 'translateX(-12px) translateY(-6px)',
        }}
      />
    </div>
  )
}
